import { setConsumer } from "@inertia-cable/react";
import type { Consumer } from "@rails/actioncable";
import { createConsumer } from "@rails/actioncable";

let instance: Consumer | null = null;

export function getConsumer(): Consumer {
  if (!instance) {
    instance = createConsumer();
    // Single WebSocket connection shared between notification and inertia-cable subscriptions.
    setConsumer(instance);
  }
  return instance;
}
